import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const Outfits = lazy(() => import('pages/outfits'));

const Loader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/outfits')({
  component: OutfitsWrapper,
});

function OutfitsWrapper() {
  return (
    <Suspense fallback={<Loader />}>
      <Outfits />
    </Suspense>
  );
}
